import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// inspired from https://tobbelindstrom.com/blog/resize-observer-hook/

import { useRef, useLayoutEffect, useState, useCallback, useEffect } from 'react';
var useResizeObserver = function useResizeObserver() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    observerEntry = _useState2[0],
    setObserverEntry = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    node = _useState4[0],
    setNode = _useState4[1];
  var observer = useRef(null);
  var disconnect = useCallback(function () {
    var _observer$current;
    return (_observer$current = observer.current) === null || _observer$current === void 0 ? void 0 : _observer$current.disconnect();
  }, []);
  var observe = useCallback(function () {
    observer.current = new ResizeObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      return setObserverEntry(entry);
    });
    if (node) {
      observer.current.observe(node);
    }
  }, [node]);
  useLayoutEffect(function () {
    observe();
    return function () {
      return disconnect();
    };
  }, [disconnect, observe]);
  return [setNode, observerEntry];
};
export default useResizeObserver;